module.exports = __webpack_public_path__ + "img/cardbackground.2266c81d.png";